import * as Redux from 'redux';
import { Action as AppAction } from 'acscp/actions';

/**
 * Redux middleware which converts our actions into standard redux actions
 */
export const appActionReduxifierMiddleware: Redux.Middleware =
    <S>(store: Redux.Store<S>) =>
        (next: Redux.Dispatch): Redux.Dispatch =>
            <TAction extends Redux.AnyAction>(action: TAction): Redux.AnyAction => {
                const actionToDispatch = action instanceof AppAction ? action.makeReduxAction() : action;
                return next(actionToDispatch);
            };
